// German for the people board. Keys already in i18n/common.de.ts (Held, Confirm, Loading…,
// us, them, late, due, not collected, People, Review …) are NOT repeated here: the console
// warns when two catalogues disagree about one English key, and the first registration wins.
import { registerDe } from '../i18n/index.js';

registerDe({
  // ── the masthead ──
  'ranked by the rule that fired': 'nach der Regel geordnet, die ausgelöst hat',
  'candidates': 'Kandidaten',
  'name is the last tie-break': 'der Name entscheidet zuletzt',
  'New person': 'Neue Person',

  // ── the rail ──
  'Candidates': 'Kandidaten',
  'Ball': 'Ball',
  // 'Cooling' is TodayPage's word (Abkühlend) — registered there, not repeated here.
  'New · 7d': 'Neu · 7 T',
  '{orgs} organisations · {a} tier A': '{orgs} Organisationen · {a} Stufe A',
  'named by evidence · not on the record': 'durch Belege benannt · nicht im Bestand',
  'nothing proposed itself as a person': 'nichts hat sich als Person vorgeschlagen',
  'the candidates could not be read': 'die Kandidaten konnten nicht gelesen werden',
  'us · {n} late': 'wir · {n} überfällig',
  '{n} with them': '{n} bei ihnen',
  'past their tier cadence · {a} of them tier A': 'über der Taktung ihrer Stufe · davon {a} Stufe A',
  'nobody is past their tier cadence': 'niemand ist über der Taktung seiner Stufe',
  '{i} from the import · {o} from you': '{i} aus dem Import · {o} von Ihnen',
  'the board is still loading': 'die Übersicht lädt noch',
  'the board did not answer': 'die Übersicht hat nicht geantwortet',
  'The board did not answer': 'Die Übersicht hat nicht geantwortet',

  // ── the chips and the search ──
  'Needs a move': 'Braucht einen Zug',
  'Tier A': 'Stufe A',
  'Everyone': 'Alle',
  'Name, organisation, role, ref…': 'Name, Organisation, Funktion, Referenz…',
  'Search people': 'Personen durchsuchen',

  // ── the zone and the rows ──
  'the lead card is the person the data says to write to first':
    'die Leitkarte ist die Person, an die die Daten zuerst zu schreiben raten',
  'Last contact': 'Letzter Kontakt',
  'Tier': 'Stufe',
  'no organisation on record': 'keine Organisation erfasst',
  'ball': 'Ball',
  'late since': 'überfällig seit',
  'last interaction {date}': 'letzter Kontakt {date}',
  'no interaction on record': 'kein Kontakt erfasst',
  'Show {n} more': 'Weitere {n} anzeigen',
  '{shown} of {total} shown': '{shown} von {total} angezeigt',
  'One row matched, and it is the card above.': 'Eine Zeile passt, und das ist die Karte oben.',

  // ── the states a row can be in ──
  'cooling': 'kühlt ab',
  'new': 'neu',
  'warm': 'warm',
  'quiet': 'still',

  // ── the empty states ──
  'Nobody matches': 'Niemand passt',
  'The filter is “{chip}”{q}{cells}. There are {n} people on the record.':
    'Der Filter ist «{chip}»{q}{cells}. Im Bestand stehen {n} Personen.',
  ' and the search is “{q}”': ' und die Suche lautet «{q}»',
  ' and the cells are {cells}': ' und die Zellen lauten {cells}',
  'Nobody on the record yet': 'Noch niemand im Bestand',
  'A person arrives from the seed import, from a held candidate proposal, or from New person. Until one of those happens this register is genuinely empty.':
    'Eine Person entsteht aus dem Seed-Import, aus einem übernommenen Kandidatenvorschlag oder über «Neue Person». Bis eines davon geschieht, ist dieses Verzeichnis tatsächlich leer.',
  'Nobody needs a move. A person appears here when the ball is with us, when it is late, or when they have cooled past their tier’s cadence.':
    'Niemand braucht einen Zug. Eine Person erscheint hier, wenn der Ball bei uns liegt, wenn er überfällig ist, oder wenn sie über der Taktung ihrer Stufe abgekühlt ist.',

  // ── candidates ──
  'named by evidence, not on the record · promote or refuse in Review':
    'durch Belege benannt, nicht im Bestand · in der Prüfung übernehmen oder ablehnen',
  'not on the record': 'nicht im Bestand',
  'Promote to person': 'Zur Person machen',
  'Holds {ref} and writes the row': 'Übernimmt {ref} und schreibt die Zeile',
  'No proposal behind this row — its status is flipped directly':
    'Hinter dieser Zeile steht kein Vorschlag — ihr Status wird direkt umgestellt',
  'No candidate matches the search. {n} are waiting.':
    'Kein Kandidat passt zur Suche. {n} warten.',
  'Nothing has proposed itself as a person. Candidates arrive from a lookalike run or a registry publication, and they stay off the record until you promote one.':
    'Nichts hat sich als Person vorgeschlagen. Kandidaten entstehen aus einem Lookalike-Lauf oder einer Registerpublikation und bleiben ausserhalb des Bestands, bis Sie einen übernehmen.',
  '{name} is on the record. {ref} is held.': '{name} steht im Bestand. {ref} ist übernommen.',
  '{name} is on the record.': '{name} steht im Bestand.',

  // ── round 2 (§10): the score slot and the "By score" sort ──
  'Sort': 'Sortierung',
  'By rule': 'Nach Regel',
  'By score': 'Nach Bewertung',
  'Order by the rule that fired: late, then ours, then cooling.':
    'Nach der Regel ordnen, die ausgelöst hat: überfällig, dann bei uns, dann abkühlend.',
  'Order by the score the rules produced. Somebody nobody has scored sorts last.':
    'Nach der Bewertung ordnen, die die Regeln erzeugt haben. Wer nicht bewertet wurde, steht zuletzt.',
  'Score': 'Bewertung',
  'score': 'Bewertung',
  'not scored': 'nicht bewertet',

  // ── the new-person dialogue ──
  'Add to the record': 'In den Bestand aufnehmen',
  'Name': 'Name',
  'Full name as they write it': 'Vollständiger Name, so wie die Person ihn schreibt',
  'A person needs a name.': 'Eine Person braucht einen Namen.',
  '{name} added as {ref}.': '{name} als {ref} aufgenommen.',
  'A · 30 day cadence': 'A · Taktung 30 Tage',
  'B · 90 day cadence': 'B · Taktung 90 Tage',
  'C · 180 day cadence': 'C · Taktung 180 Tage',
  'The person is written with the correspondence language French and no affiliation. Attach an organisation and set the register from their brief.':
    'Die Person wird mit der Korrespondenzsprache Französisch und ohne Zugehörigkeit angelegt. Organisation und Anrede setzen Sie in ihrem Dossier.',

  // ── round 3b: the tree filter ──
  'In the tree of {name}': 'Im Baum von {name}',
  'Everyone affiliated with {name} or with a unit under it. Click to see the whole register again.':
    'Alle, die {name} oder einer Einheit darunter zugeordnet sind. Klicken, um wieder das ganze Register zu sehen.',
  'The tree could not be read: {error}': 'Der Baum konnte nicht gelesen werden: {error}',
  'The tree could not be read.': 'Der Baum konnte nicht gelesen werden.',

  // ── round 7 §6.2: die Zellenfilter und die ehrliche Zählung ──
  // Zellennamen und Tokens kommen aus person-raster.v1.ts (personLabelFor) und stehen NIE hier:
  // eine zweite Schreibweise derselben Zelle wäre genau der Fehler, den das Raster verhindert.
  'Cells': 'Zellen',
  'any': 'beliebig',
  'Clear cells': 'Zellen zurücksetzen',
  'Ask the register nothing about its cells again; the chips and the search stay as they are.':
    'Dem Register keine Zellenfrage mehr stellen; Chips und Suche bleiben, wie sie sind.',
  '{rank} and above': '{rank} und höher',
  'estimated': 'geschätzt',
  'from the title': 'aus dem Titel',
  'counted on {cells} · over {n} people the cell filters match':
    'gezählt auf {cells} · über {n} Personen, auf die die Zellenfilter passen',
  'the cell count could not be read: {error}': 'die Zellenzählung konnte nicht gelesen werden: {error}',
  '{cell}: {value} · read from a source': '{cell}: {value} · aus einer Quelle gelesen',
  '{cell}: {value} · estimated by an agent': '{cell}: {value} · von einem Agenten geschätzt',
  '{cell}: {value} · computed by the nightly job': '{cell}: {value} · vom Nachtlauf berechnet',
  '{cell}: {value} · declared by you': '{cell}: {value} · von Ihnen erklärt',
  '{cell}: {value} · searched for and not found': '{cell}: {value} · gesucht und nicht gefunden',
}, 'PeoplePage');
